import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import {
  CacheConstant,
  UserProperty,
  RequestHeaders
} from '../constants/app.constant';
import { AppUtilService } from '../utils/app-util.service';
import { PublisherService } from './publisher.service';
import 'rxjs/add/operator/switchMap';
import { ParmedApiService as ParmedApi } from '../api/parmed-api.service';
import { StaticConstants } from '../constants/static.constants';
import { OktaAuthService } from './okta-auth.service';
import { of } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppCacheService } from './cache/app-cache.service';

@Injectable()
export class AuthService {
  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    private http: HttpService,
    private oktaAuthSevice: OktaAuthService,
    private api: ParmedApi
  ) {}
  /***************Constructor***************/

  /***************Helper Methods***************/

  isAuthenticated() {
    const details = AppUtilService.cache.get(CacheConstant.User_Auth_Detail);
    const tokens = this.getAuthorizationTokens();
    const hasToken = !String.isNullOrEmpty(tokens[RequestHeaders.AccessToken]);
    const hasUserDetails =
      details &&
      details[UserProperty.UserDetailNumber] &&
      details[UserProperty.OktaId]
        ? true
        : false;

    return hasToken && hasUserDetails;
  }

  getAuthorizationTokens() {
    const tokens = {};
    tokens[RequestHeaders.AccessToken] = '';

    const authTokens = AppUtilService.cache.get(CacheConstant.Auth_Tokens);
    if (authTokens) {
      tokens[RequestHeaders.AccessToken] =
        authTokens[RequestHeaders.AccessToken];
    }

    return tokens;
  }

  /***************Helper Methods***************/

  /***************Service Methods***************/

  authenticate() {
    const authObj = {
      sessionID: AppUtilService.cache.get(CacheConstant.Okta_Session_Id),
      username: AppUtilService.getUserSuffixId(
        AppUtilService.cache.get(CacheConstant.User_Id)
      ),
      buId: this.cache.get(CacheConstant.Env_Properties).buId
    };

    return this.http.post(this.api.Login.AUTHENTICATE_USER_URL, authObj);
  }

  authenticateIdm(username, password) {
    const userObj = {
      username: username,
      password: password
    };
    return this.http
      .post(this.api.Login.AUTHENTICATE_IDM_USER_URL, userObj)
      .switchMap((response: any) => {
        if (!response || !response.hasError) {
          return this.http
            .post(this.api.Login.GET_RECOVERY_TOKEN_URL, {
              username: username,
              buId: this.cache.get(CacheConstant.Env_Properties).buId
            })
            .map((tokenResponse: any) => {
              return tokenResponse;
            });
        } else {
          return of(response);
        }
      });
  }

  signOut() {
    return this.oktaAuthSevice.signOut().switchMap((oktaResponse: any) => {
      AppUtilService.cache.remove(CacheConstant.Okta_Session_Id);
      AppUtilService.cache.set(CacheConstant.Show_Login_Popup, false);
      
      const logoutObj = {
        appType: 1,
        operationType: StaticConstants.TypeRef.Logout
      };

      return this.http
        .post(this.api.Idm.LOGOUT_USER_URL, logoutObj)
        .map(response => {
          const cacheKeys = Object.keys(CacheConstant).filter(
            key => CacheConstant[key] !== CacheConstant.Static_Data && CacheConstant[key] !== CacheConstant.Env_Properties && CacheConstant[key] !== CacheConstant.Show_Login_Popup
          );

          for (const key of cacheKeys) {
            AppUtilService.cache.remove(CacheConstant[key]);
          }

          PublisherService.notifyAuth(false);
          return response;
        });
    });
  }

  /***************Service Methods***************/
}
